import { init, RematchRootState } from '@rematch/core'
import createLoadingPlugin from '@rematch/loading'
import selectPlugin, { getSelect } from '@rematch/select'

import * as models from './models'

export { models }
export type models = typeof models

export const store = init({
  plugins: [selectPlugin(), createLoadingPlugin()],
  models
})

interface LoadingPlugin {
  loading: {
    models: any;
    effects: any;
  }
}

export type Store = typeof store
export type Dispatch = typeof store.dispatch
export type RootState = RematchRootState<typeof models> & LoadingPlugin

export const select = getSelect<models>()
export const { dispatch } = store



// WEBPACK FOOTER //
// ./src/store.ts